(function () {
  'use strict';
  angular.module('cbl.finanza.mf.directives').directive('finDossierHeader', [
    'CommonUtilitiesSrvc',
    'CblMessageSrvc',
    'FIN_CONSTANTS',
    '$http',
    '$stateParams',
    'FinMessaggiFctr',
    'FinUploadSrvc',
    'FinLabelSrvc',
    function (
      commonUtilities,
      messaggiSrvc,
      CONSTANTS,
      $http,
      $stateParams,
      messaggiFctr,
      FinUploadSrvc,
      labelSrvc
    ) {
      var directiveImpl = function ($scope) {
        var self = this;

        $scope.loading = false;

        $scope.commonUtilities = commonUtilities;
        $scope.messaggiSrvc = messaggiSrvc;
        $scope.msg = labelSrvc.getLabel;

        $scope.spinner = $scope.commonUtilities.getSpinnerStyle($scope);
        $scope.finSpinner = {
          reportData: false,
          report: false
        };
        $scope.stateParams = $stateParams;
        $scope.configurazioneEffe = {};
        $scope.listaCampi = {};
        $scope.reportEffeSelectedConfiguration;
        $scope.FinUploadSrvc = FinUploadSrvc;

        console.log($scope.finDataContratto);

        if (!$scope.dossierDivisa) {
          $scope.dossierDivisa = 'EUR';
        }

        if (!$scope.dossierCambio) {
          console.log('Cambio non impostato, setto default (1)');
          $scope.dossierCambio = 1;
        }

        if (!$scope.dossierDecimali) {
          $scope.dossierDecimali = 2;
        }

        $scope.getCustomer = function () {
          return {
            ndg: $scope.customerNdg,
            idAnagrafica: $scope.customerIdAnagrafica,
            naturaGiuridica: $scope.customerLegalNature
          };
        };
        $scope.promiseReportEffeConf = function (codicePortafoglio) {
          return $http({
            method: 'GET',
            url:
              CONSTANTS.REST_ROOT +
              CONSTANTS.REST.REPORT +
              '/' +
              codicePortafoglio
          });
        };
        //Ritorna la configurazione per scaricare il report effe
        $scope.getReportEffeConf = function () {
          $scope.finSpinner.reportData = true;
          $scope
            .promiseReportEffeConf($stateParams.finCodiceRapporto)
            .then(function (response) {
              if (messaggiFctr.processaResponse(response)) {
                $scope.finSpinner.reportData = false;
                return;
              }
              $scope.configurazioneEffe = response.data.result;
              $scope.assignEffeConfiguration(0);
            })
            .finally(function () {
              $scope.finSpinner.reportData = false;
            });
        };
        $scope.assignEffeConfiguration = function (index) {
          $scope.listaCampi =
            this.configurazioneEffe.elencoConfigurazioni[index].elencoCampi;
          this.listaCampi.forEach(function (campo) {
            if (campo.valore === 'true') {
              campo.valore = true;
            } else if (campo.valore === 'false') {
              campo.valore = false;
            }
          });
          $scope.reportEffeSelectedConfiguration = index;
        };
        $scope.promisePostReportEffeConf = function () {
          return $http({
            method: 'POST',
            url:
              CONSTANTS.REST_ROOT +
              CONSTANTS.REST.REPORT +
              '/' +
              $stateParams.finCodiceRapporto,
            data: this.configurazioneEffe.elencoConfigurazioni[
              $scope.reportEffeSelectedConfiguration
            ]
          });
        };
        $scope.postEffeConfiguration = function () {
          $scope.finSpinner.report = true;
          this.listaCampi.forEach(function (campo) {
            if (campo.campo.tipo === 'DATE') {
              campo.valore = campo.valore.toISOString().substring(0, 10);
            }
          });
          $('#reportModal').modal('hide');
          $scope.promisePostReportEffeConf().then(function (response) {
            if (messaggiFctr.processaResponse(response)) {
              $scope.finSpinner.report = false;
              return;
            } else {
              $scope.finSpinner.report = false;
              var pdfString = response.data.result;
              $scope.FinUploadSrvc.download(pdfString, 'report-effe.pdf');
            }
          });
        };
      };
      directiveImpl.$inject = ['$scope'];
      return {
        restrict: 'E',
        scope: {
          customerHeader: '=?customerHeader',
          customerNdg: '=?customerNdg',
          customerLegalNature: '=?customerLegalNature',
          customerFiscalCode: '=?customerFiscalCode',
          customerIdAnagrafica: '=?customerIdAnagrafica',
          customerPunteggioAdeguatezza: '=?customerPunteggioAdeguatezza',
          customerPunteggioAppropriatezza: '=?customerPunteggioAppropriatezza',
          customerContoCorrente: '=?customerContoCorrente',
          customerTipologiaCliente: '=?customerTipologiaCliente',
          customerPaese: '=?customerPaese',
          customerProvincia: '=?customerProvincia',
          customerComune: '=?customerComune',
          customerCap: '=?customerCap',
          customerIndirizzo: '=?customerIndirizzo',
          customerAttivitaConsob: '=?customerAttivitaConsob',
          customerPromotore: '=?customerPromotore',
          dossierAbilitatoConsulenza: '=?dossierAbilitatoConsulenza',
          dossierAbilitatoCollocamento: '=?dossierAbilitatoCollocamento',
          dossierNumber: '=?dossierNumber',
          dossierProductDescription: '=?dossierProductDescription',
          dossierStartDate: '=?dossierStartDate',
          dossierLockDate: '=?dossierLockDate',
          dossierEndDate: '=?dossierEndDate',
          dossierContovaloreTitoli: '=?dossierContovaloreTitoli',
          dossierBalanceAvailableCcEuro: '=?dossierBalanceAvailableCcEuro',
          dossierBalanceAvailableCdEuro: '=?dossierBalanceAvailableCdEuro',
          dossierBalanceCountingCcEuro: '=?dossierBalanceCountingCcEuro',
          dossierBalanceCountingCdEuro: '=?dossierBalanceCountingCdEuro',
          dossierBalanceTotEuro: '=?dossierBalanceTotEuro',
          doNotShowExportButton: '=?doNotShowExportButton',
          dossierDivisa: '=?',
          dossierCambio: '=?',
          dossierDecimali: '=?',
          isDossierBtnEnabled: '=?isDossierBtnEnabled',
          customerDettagliEsg: '=?customerDettagliEsg',
          customerPunteggioEsg: '=?customerPunteggioEsg',
          finDataContratto: '=?finDataContratto',
          esgVisibile: '=?esgVisibile'
        },
        templateUrl:
          CONSTANTS.BASE_ROOT +
          'widgets/finDossierHeader/finDossierHeader.html',
        replace: true,
        controller: directiveImpl
      };
    }
  ]);
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/finDossierHeader/finDossierHeaderDrct.js
 ** module id = 31
 ** module chunks = 1 2
 **/